@if (isAdmin()) {
	<div class="header-buttons">
		@if (!showForm()) {
			<button nz-button nzType="primary" title="New {{ modelName() }}" (click)="requestShowForm()">
				New {{ modelName() }}
			</button>
		} @else {
			<button nz-button nzType="default" title="Back to List" (click)="hideForm()">Cancel</button>
		}
	</div>
}

<nz-spin [nzSpinning]="loading()">
	<div class="both-container">
		<div class="table-container">
			<ng-container *ngTemplateOutlet="tableTemplate"></ng-container>
		</div>
		@if (showForm()) {
			<div class="form-container">
				<ng-container *ngTemplateOutlet="formTemplate"></ng-container>
			</div>
		}
	</div>
</nz-spin>
